import React, { useEffect, useState } from "react";
import { db } from "./firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import "./WithdrawalSettings.css";

export default function WithdrawalSettings() {
  const [minPoints, setMinPoints] = useState("");
  const [pointsPerRupee, setPointsPerRupee] = useState("");

  useEffect(() => {
    async function fetchSettings() {
      const snap = await getDoc(doc(db, "config", "withdrawalSettings"));
      if (snap.exists()) {
        const data = snap.data();
        setMinPoints(data.minPoints);
        setPointsPerRupee(data.pointsPerRupee);
      }
    }
    fetchSettings();
  }, []);

  const handleSave = async () => {
    await updateDoc(doc(db, "config", "withdrawalSettings"), {
      minPoints: parseInt(minPoints),
      pointsPerRupee: parseInt(pointsPerRupee)
    });
    alert("Settings updated ✅");
  };

  return (
    <div className="withdrawal-settings">
      <h2>Withdrawal Settings</h2>
      <label>Minimum Points to Withdraw</label>
      <input
        type="number"
        value={minPoints}
        onChange={e => setMinPoints(e.target.value)}
      />

      <label>Points per ₹1</label>
      <input
        type="number"
        value={pointsPerRupee}
        onChange={e => setPointsPerRupee(e.target.value)}
      />

      <button onClick={handleSave}>Save</button>
    </div>
  );
}
